import { API } from '~/data/api'

export const useChallengesService = () => {
  async function getChallenges(isoCode: string) {
    const response = await API.getChallenges(isoCode)

    return response?.data
  }

  async function getChallenge(id: string) {
    const response = await API.getChallenge(id)
    return response?.data
  }

  async function joinChallenge(id: string | number) {
    const response = await API.joinChallenge(id)
    return response?.data
  }

  async function leaveChallenge(id: string | number) {
    const response = await API.leaveChallenge(id.toString())
    return response?.data
  }

  async function getCustomChallenge(id: string) {
    const response = await API.getCustomChallenge(id)
    return response?.data
  }

  async function joinCustomChallenge(id: string) {
    const response = await API.joinCustomChallenge(id)
    return response?.data
  }

  async function leaveCustomChallenge(id: string) {
    const response = await API.leaveCustomChallenge(id)
    return response?.data
  }

  return {
    getChallenges,
    getChallenge,
    joinChallenge,
    leaveChallenge,
    getCustomChallenge,
    joinCustomChallenge,
    leaveCustomChallenge
  }
}
